<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_name" [ttModel]="edit.prod_name" ttReadonly></tt-input>
        <tt-input ttLabel="choice_prod_name" [ttModel]="edit.choice_prod_name" ttReadonly></tt-input>
        <tt-select ttLabel="move_to_comp_keyno" [(ttModel)]="edit.move_to_comp_keyno" [ttData]="selectListMoveTo" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-button-save [hidden]="edit.move_to_comp_keyno_before === edit.move_to_comp_keyno" ttText="productmovechoice_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
